import { render, staticRenderFns } from "./editFeedback.vue?vue&type=template&id=5039d9ae&scoped=true"
import script from "./editFeedback.vue?vue&type=script&lang=js"
export * from "./editFeedback.vue?vue&type=script&lang=js"
import style0 from "./editFeedback.vue?vue&type=style&index=0&id=5039d9ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039d9ae",
  null
  
)

export default component.exports